import { IssuesModule } from '@core/modules/issues'

const useIsIssueInProcess = (
    issueId?: string
): { isIssueInProcess: boolean; checkIsIssueInProcess: (issueId: string) => boolean } => {
    const { inProcessIssues } = IssuesModule.useStore()

    const checkIsIssueInProcess = (issueId: string): boolean => {
        return inProcessIssues.has(issueId)
    }

    return {
        isIssueInProcess: !!(issueId && checkIsIssueInProcess(issueId)),
        checkIsIssueInProcess,
    }
}

export default useIsIssueInProcess
